import React, { Suspense, lazy } from 'react';
import ITRouteFallback from './ITRouteFallback';

const ITWorkspacePage = lazy(() => import('./pages/ITWorkspacePage'));

export const itRoutes = [
  {
    path: 'it',
    element: (
      <Suspense fallback={<ITRouteFallback />}>
        <ITWorkspacePage />
      </Suspense>
    ),
  },
];